import { IonInput, IonButton, IonCard, IonModal, IonProgressBar, IonText, useIonToast} from "@ionic/react";
import * as XLSX from "xlsx";
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { setPreselectUser } from "../../../store/massiveDocumentCreate";
import { selectEnabledUsers } from "../../../store/massiveDocumentCreate/selectors/selectEnabledUsers";
import { selectSelectedUsers } from "../../../store/massiveDocumentCreate/selectors/selectSelectedUsers";

const UsersExcelUploader = () => {
  const dispatch = useDispatch();
  const enabledUsers = useSelector(selectEnabledUsers);
  const selectedUsers = useSelector(selectSelectedUsers);
  const [showModal, setShowModal] = useState(false);
  const [progreso, setProgreso] = useState(0);
  const [noEncontrados, setNoEncontrados] = useState<string[]>([]);
  const [totalProcesados, setTotalProcesados] = useState(0);
  const [presentToast] = useIonToast();

  useEffect(() => {
    if (totalProcesados > 0) {
      setProgreso(selectedUsers.length / totalProcesados);
    }
  }, [selectedUsers.length, totalProcesados]);


  const handleFileUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    // Open the modal before any heavy processing
    setShowModal(true);
    setNoEncontrados([]);


    // Wait a bit longer to ensure the modal renders
    await new Promise((resolve) => setTimeout(resolve, 300));

    const data = await file.arrayBuffer();
    const workbook = XLSX.read(data);
    const worksheet = workbook.Sheets["NOMINA PERSONAL"];

    if (!worksheet) {

      presentToast({
        message: "\"El archivo Excel no contiene la hoja 'NOMINA PERSONAL'. Por favor verifica que el archivo tenga el nombre correcto y vuelve a intentarlo.\"",
        duration: 6000,
        color: "danger",
      });
      return;
    }

    const jsonData = XLSX.utils.sheet_to_json(worksheet, {
      range: 0,
      defval: "",
    });

    const nombres: string[] = jsonData
      .map((row: any) => row["NOMBRE"]?.toString().trim())
      .filter(Boolean);

    const normalizarTexto = (texto: string) =>
      texto
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/\s+/g, " ")
        .trim()
        .toLowerCase();

    const nombresNormalizados = nombres.map(normalizarTexto);
    const yaSeleccionados = new Set();
    const nuevosNoEncontrados: string[] = [];


    setProgreso(0);
    setTotalProcesados(nombres.length);

    for (let i = 0; i < nombresNormalizados.length; i++) {
      const nombre = nombresNormalizados[i];
      const userRole = enabledUsers.find((u) => {
        if (!u.user.name) return false;
        return (
          normalizarTexto(u.user.name).includes(nombre) &&
          !yaSeleccionados.has(u.id)
        );
      });

      if (userRole) {
        dispatch(setPreselectUser(userRole));
        yaSeleccionados.add(userRole.id);
      } else {
        nuevosNoEncontrados.push(nombres[i]);
      }

      // Actualiza la barra de progreso después de cada paso
      setTotalProcesados(nombres.length);
      setProgreso((i + 1) / nombres.length);

      // Espera un poquito para que el DOM actualice visualmente (opcional)
      await new Promise((r) => setTimeout(r, 5));
    }

    setNoEncontrados(nuevosNoEncontrados);
  };

  return (
    <>

        <IonButton
          expand="block"
          color="primary"
          onClick={() => document.getElementById('excel-file-input')?.click()}
        >
          Subir archivo Excel
        </IonButton>
        <input
          id="excel-file-input"
          type="file"
          accept=".xlsx"
          onChange={handleFileUpload}
          style={{ display: "none" }}
        />
      <IonModal isOpen={showModal} onDidDismiss={() => setShowModal(false)}>
        <IonCard className="ion-padding" style={{ maxHeight: "80vh", overflowY: "auto" }}>
          {selectedUsers.length + noEncontrados.length === totalProcesados && (
            <div style={{ position: "absolute", top: "16px", right: "16px" }}>
              <IonButton
                size="small"
                onClick={() => {
                  const texto = noEncontrados.join("\n");
                  navigator.clipboard.writeText(texto);
                }}
              >
                Copiar al portapapeles
              </IonButton>
            </div>
          )}
          <IonText color="medium">
            <p>
              Procesando {selectedUsers.length} de {totalProcesados}
            </p>
          </IonText>
          <IonProgressBar value={progreso}></IonProgressBar>
          {noEncontrados.length > 0 && (
            <>
              <IonText color="dark">
                <p>
                  Encontrados: {totalProcesados - noEncontrados.length} <br />
                </p>
              </IonText>
              <IonText color="danger">
                <p>No encontrados: {noEncontrados.length}</p>
              </IonText>
              <ul>
                {noEncontrados.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ul>
            </>
          )}
          <IonButton expand="block" color="medium" onClick={() => setShowModal(false)}>
            Cerrar
          </IonButton>
        </IonCard>
      </IonModal>
    </>
  );
};

export default UsersExcelUploader;
